var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlineBakhishIcon = function SvgOnlineBakhishIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M26.5 17.133h-14a4.533 4.533 0 0 0-4.533 4.534v6A4.533 4.533 0 0 0 12.5 32.2h14a4.533 4.533 0 0 0 4.533-4.533v-6a4.533 4.533 0 0 0-4.533-4.534m-14-1.466a6 6 0 0 0-6 6v6a6 6 0 0 0 6 6h14a6 6 0 0 0 6-6v-6a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M19.278 12.148a3.396 3.396 0 0 0 3.15 2.6l-.221-2.83zm2.84-1.36-2.92.23a3.4 3.4 0 0 1 2.704-3zm1.219 1.042.217 2.779a3.39 3.39 0 0 0 2.42-2.985zm2.539-1.335-2.628.205-.212-2.722a3.41 3.41 0 0 1 2.84 2.517m.902 2.576a4.534 4.534 0 1 0-8.388-3.443 4.534 4.534 0 0 0 8.388 3.443",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M14.01 8.036a3.396 3.396 0 0 0-3.553 2.014l2.721.804zm.255 3.139.83-2.81a3.397 3.397 0 0 1 1.836 3.596zm-1.408.765-2.672-.789a3.39 3.39 0 0 0 1.923 3.327zm.34 2.849.747-2.527 2.62.773a3.41 3.41 0 0 1-3.366 1.754m-2.728-.077a4.534 4.534 0 1 0 6.213-6.606 4.534 4.534 0 0 0-6.213 6.606",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m21.443 38.604-2.61-4.541-2.609 4.54zm-1.119-5.406a1.718 1.718 0 0 0-2.982 0l-2.609 4.54c-.662 1.154.166 2.595 1.491 2.595h5.218c1.326 0 2.154-1.441 1.491-2.594z",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M36.844 31.314a2.33 2.33 0 0 1-1.48-.514L31.5 27.703a.84.84 0 0 1-.329-.566.81.81 0 0 1 .188-.623.85.85 0 0 1 .59-.302.87.87 0 0 1 .634.203l3.865 3.097a.5.5 0 0 0 .39.136.63.63 0 0 0 .437-.175.6.6 0 0 0 .18-.425l.013-8.445a.6.6 0 0 0-.094-.322.6.6 0 0 0-.257-.223.63.63 0 0 0-.655.08l-3.88 3.097a.86.86 0 0 1-.632.2.87.87 0 0 1-.587-.304.83.83 0 0 1-.188-.621.82.82 0 0 1 .326-.565l3.879-3.097a2.375 2.375 0 0 1 2.47-.295c.398.184.734.475.969.838.235.364.359.786.358 1.216l-.014 8.444c0 .297-.06.592-.177.866a2.3 2.3 0 0 1-.504.735c-.215.21-.471.377-.753.49a2.4 2.4 0 0 1-.888.172z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIcon_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M36.844 31.314h.003c.303 0 .603-.059.883-.172.282-.113.538-.28.754-.49s.386-.46.503-.735.177-.569.177-.866l.014-8.444a2.23 2.23 0 0 0-.358-1.215 2.3 2.3 0 0 0-.969-.84 2.38 2.38 0 0 0-2.47.296l-3.88 3.097a.84.84 0 0 0-.325.565.81.81 0 0 0 .188.621.85.85 0 0 0 .587.303.88.88 0 0 0 .632-.199l3.88-3.097a.62.62 0 0 1 .655-.08.6.6 0 0 1 .257.223.6.6 0 0 1 .094.322l-.013 8.445a.59.59 0 0 1-.18.425.61.61 0 0 1-.437.175.51.51 0 0 1-.39-.136l-3.865-3.097a.86.86 0 0 0-.633-.203.87.87 0 0 0-.59.302.83.83 0 0 0-.189.623.82.82 0 0 0 .328.566l3.864 3.097c.415.336.938.518 1.478.514zm-.002-.666h.001c.22 0 .436-.043.638-.124s.384-.2.537-.35m-1.176.474v.366l-.003-.366a1.66 1.66 0 0 1-1.056-.366l-3.874-3.106-.009-.006a.2.2 0 0 1-.046-.052.149.149 0 0 1-.014-.119m.088-.101a.2.2 0 0 1 .156-.012q.038.012.067.037l.008.006 3.857 3.09a1.17 1.17 0 0 0 .846.295 1.3 1.3 0 0 0 .879-.363m0 0q.181-.177.282-.413zm.381-.904.014-8.44v-.002m-.2-.686a1.3 1.3 0 0 0-.538-.466 1.3 1.3 0 0 0-1.352.165m.605-.606c.315-.038.634.013.92.145.285.132.523.34.69.596m.25.852c.001-.3-.086-.596-.25-.852m.25.852-.014 8.445zm-.014 8.445c0 .208-.042.414-.123.607zm-.123.607a1.6 1.6 0 0 1-.356.517z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__a",
    width: 38.8,
    height: 30.8,
    x: 0.1,
    y: 9.267,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__b",
    width: 21.87,
    height: 21.87,
    x: 11.649,
    y: 0.414,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__c",
    width: 21.868,
    height: 21.868,
    x: 2.642,
    y: 0.475,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__d",
    width: 21.467,
    height: 20.8,
    x: 8.1,
    y: 25.933,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__e",
    width: 20.811,
    height: 25.781,
    x: 24.767,
    y: 11.933,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIcon_svg__f",
    width: 8.211,
    height: 13.181,
    x: 31.067,
    y: 18.233,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.796826 0 0 0 0 0.0705783 0 0 0 0 0.0916289 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_7632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_80_7632",
    result: "shape"
  })))));
};
export default SvgOnlineBakhishIcon;